// extracted by mini-css-extract-plugin
export default {"container":"education_container__MMDwV","title":"education_title__MiEhh","timeline-card":"education_timeline-card__NFWvO"};